<cap-autocomplete
  appInputPrefix
  [prefix]="props.prefix"
  [prefixDisabled]="!props.prefix"
  [formControl]="formControl"
  (completeMethod)="props.filterResults?.($event, field)"
  (onSelect)="props.onSelect?.(field, $event)"
  [suggestionsFilter]="props.suggestionsFilter || []"
  [dropdown]="props.dropdown"
  [placeholder]="props.placeholder"
  [label]="props.label"
  [styleClass]="props.styleClass"
  [readonly]="props.readonly" />
